//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export interface IReferralSourceStats {
  [SummaryReferralsSource.Like2Buy]?: number;
  [SummaryReferralsSource.Stories]?: number;
  [SummaryReferralsSource.PromotedPosts]?: number;
  [SummaryReferralsSource.ShopTags]?: number;
  totalCount?: number;
}

export interface IReferralStats {
  revenue: IReferralSourceStats;
  traffic: IReferralSourceStats;
}

export const SummaryReferralsSource = {
  Like2Buy: 'LIKE2BUY',
  Stories: 'STORIES',
  PromotedPosts: 'PROMOTED_POSTS',
  ShopTags: 'SHOP_TAGS',
} as const;

export type SummaryReferralsSource =
  (typeof SummaryReferralsSource)[keyof typeof SummaryReferralsSource];
